import { useUser } from 'src/lib/contexts/UserContext'
import { OrganisationType } from 'src/lib/types/user'
import StoreListItem from './StoreListItem'

interface StoreListProps {
  quantity?: number
}

const sortOrganizations = (organizations: OrganisationType[] = []): OrganisationType[] => {
  return organizations.sort((a, b) => Number(b.logged_in) - Number(a.logged_in))
}

const StoreList = ({ quantity }: StoreListProps) => {
  const { user } = useUser()
  const sortedOrganizations = sortOrganizations(user?.organisations ?? [])

  const displayOrganizations = quantity ? sortedOrganizations.slice(0, quantity) : sortedOrganizations

  return (
    <div className='p-1.5 flex flex-col gap-0.5 overflow-y-auto max-h-[600px]'>
      {displayOrganizations.map((organization: OrganisationType) => (
        <StoreListItem key={organization.merchantId} organization={organization} isSelected={organization.logged_in} />
      ))}
    </div>
  )
}

export default StoreList
